import type { EmploymentStatus } from '@/data/types'
import { useImpersonation } from '@/context/ImpersonationContext'
import { useRosterProfile } from '@/hooks/equip/useRosterProfile'

/**
 * Resolves the effective employment status for the current user.
 *
 * Priority:
 * 1. employmentStatusOverride (admin explicitly toggled PT/FT in nav)
 * 2. selectedPersona?.employmentStatus (persona preset value)
 * 3. profile?.employmentStatus from useRosterProfile (real roster data)
 * 4. 'full-time' (safe default)
 */
export function useEffectiveEmploymentStatus(): {
  effectiveEmploymentStatus: EmploymentStatus
  isPartTime: boolean
} {
  const { employmentStatusOverride, selectedPersona } = useImpersonation()
  const { data: profile } = useRosterProfile()

  const effectiveEmploymentStatus: EmploymentStatus =
    employmentStatusOverride
    ?? selectedPersona?.employmentStatus
    ?? profile?.employmentStatus
    ?? 'full-time'

  return {
    effectiveEmploymentStatus,
    isPartTime: effectiveEmploymentStatus === 'part-time',
  }
}
